module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('insertOrderedList')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.locale["ordered list"]) + "\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('insertUnorderedList')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.locale["unordered list"]) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1e30f3ab!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/list/dashboard.vue
// module id = 620
// module chunks = 0